import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

export default function HeroSection() {
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = contentRef.current;
    if (!el) return;
    el.style.opacity = '0';
    el.style.transform = 'translateY(36px)';
    const t = setTimeout(() => {
      el.style.transition = 'opacity 1.1s cubic-bezier(0.16,1,0.3,1), transform 1.1s cubic-bezier(0.16,1,0.3,1)';
      el.style.opacity = '1';
      el.style.transform = 'translateY(0)';
    }, 150);
    return () => clearTimeout(t);
  }, []);

  return (
    <section className="relative h-screen min-h-[680px] max-h-[1000px] w-full overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="/images/MIH02354_3.jpg"
          alt="Laura Martin personal trainer London"
          className="w-full h-full object-cover object-[60%_20%]"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0e0d0c]/90 via-[#0e0d0c]/60 to-[#0e0d0c]/10" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#faf8f5] via-transparent to-transparent" style={{ background: 'linear-gradient(to top, #faf8f5 0%, transparent 25%)' }} />
      </div>

      {/* Stable in-flow content prevents header collision and keeps CTA above stats */}
      <div className="relative z-10 h-full box-border max-w-7xl mx-auto px-6 lg:px-20 pt-28 lg:pt-36 pb-24 lg:pb-20 flex items-start">
        <div ref={contentRef} className="max-w-2xl">
          {/* Eyebrow — padded well below header */}
          <div className="flex items-center gap-4 mb-4 lg:mb-6">
            <span className="w-10 h-px bg-[#c9a96e]" />
            <span className="text-[#c9a96e] text-[10px] font-sans font-semibold tracking-[0.35em] uppercase">
              London's Trusted Personal Trainer
            </span>
          </div>

          <h1
            className="text-white leading-[1.1] mb-4 lg:mb-6"
            style={{
              fontFamily: "'Cormorant Garamond', serif",
              fontSize: 'clamp(1.6rem, 5.8vw, 4.2rem)',
              fontWeight: 600,
              letterSpacing: '-0.01em',
            }}
          >
            Transform Your Body.
            <br />
            <em className="text-[#c9a96e] not-italic">Reclaim Your Confidence.</em>
          </h1>

          <p className="text-white/70 font-sans text-sm lg:text-base leading-relaxed max-w-md mb-6 lg:mb-8">
            Bespoke 1-2-1 coaching with a personal trainer London clients trust, plus online coaching and nutrition support built entirely around you.
          </p>

          <div className="flex flex-col sm:flex-row items-start gap-4">
            <Link
              to="/contact"
              className="px-8 py-3.5 bg-[#c9a96e] text-white text-[10px] font-sans font-bold tracking-[0.28em] uppercase rounded-full hover:bg-[#a8863f] hover:shadow-xl hover:shadow-[#c9a96e]/30 hover:-translate-y-0.5 transition-all duration-300"
            >
              Start Your Journey
            </Link>
          </div>
        </div>
      </div>

      {/* Scroll cue */}
      <div className="absolute bottom-10 right-8 lg:right-16 flex flex-col items-center gap-2 z-10">
        <span
          className="text-white/40 text-[9px] tracking-widest uppercase font-sans"
          style={{ writingMode: 'vertical-rl' }}
        >
          Scroll
        </span>
        <div className="w-px h-10 bg-gradient-to-b from-white/40 to-transparent" />
      </div>
    </section>
  );
}
